import React from 'react';

const CategoryCard = ({ category, isLarge = false }) => {
  return (
    <div className="relative group overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105 w-full h-full">
      <div className="relative w-full h-full">
        <img
          src={category.image}
          alt={category.title}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
        />
        {/* <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-5 lg:p-6 text-white">
          <h3 className="text-lg sm:text-xl lg:text-2xl font-bold">
            {category.title}
          </h3>
        </div> */}
      </div>
    </div>
  );
};

export default CategoryCard;

